import { Timeline } from '@uag/react-core';
import { OnboardingRequestDetailModel, StepModel, StepType } from '@uag/welcome-shared/src/api/models';
import { useTranslation } from 'react-i18next';

export const StepContact = ({ step, request }: { step: StepModel; request: OnboardingRequestDetailModel }) => {
    const { t } = useTranslation('translations');
    if (!step.user || request.currentState === 'Declined') {
        return undefined;
    }

    if (step.type === StepType.Verification && step.progress === 'Completed') {
        return (
            <Timeline.Contact
                email={step.user?.email ?? ''}
                headline={t('yourCustomerAdvisor')}
                image={step.user.profilePictureUri ?? undefined}
                name={step.user?.displayName}
                phone={step.user.phoneNumber ?? undefined}
            />
        );
    }
    return undefined;
};
